import {formatDate} from '@angular/common';
export class Login {
    guard(){
        console.log('Teste de guard!');
    }

    /**
    * Retorna o token caso o usuario esteja logado
    */
    getToken(){
        return localStorage.getItem('token');
    }
    /**
    * Guarda token no local storage
    * 
    * @param data Dados retornados da API
    */
    login(data: any) {
        let data_atu = new Date();
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('expires_in', data.expires_in);
        localStorage.setItem('data_login', formatDate(data_atu, 'yyyy-MM-dd h:mm:ss', 'en'));
    }

    /**
     * Guarda as informações do usuario logado 
     * 
     * @param data Dados retornados da API
     */
    setInfoUsuario(data: any){
        localStorage.setItem('info', JSON.stringify(data));
    }

    /**
     * Retorna as informações do usuario logado
     */
    getInfoUsuario(){
        return JSON.parse(localStorage.getItem('info'));
    }


    /**
     * Guarda o tempo de expiração do token
     * 
     * @param time Tempo que ira levar para o token expirar
     */
    setExpiredIn(time: string) {
        localStorage.setItem('token_expired_in', time);
    }

    /**
     * Desloga da aplicação
     */
    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('token_expired_in');
        localStorage.removeItem('info');
        localStorage.removeItem('data_login');
    }
}